import React, { Component } from 'react';
import '../../../resources/AdminStandardPage.css';
import AuthenticationService from '../../../services/AuthenticationService';
import DeletePUGCertificates from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import AttachmentField from '../../../components/AttachmentField/AttachmentField';
import { pugCertificateService } from '../../../services/PugCertificateService';
import ReactPaginate from 'react-paginate';

class PUGCertificate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabledDocuments: false,
      newCertificate: {
        title: '',
        document: '',
        date:''
      },
      existingCertificates: [],
      deleteCertificate: {
        openedDialog: false,
        deleteId: 0
      },
      pagination: {}
    };

    this.authentication = new AuthenticationService();
  }

  componentWillMount() {
    pugCertificateService
      .getAll()
      .then(jsonResponse => {
        this.setPugCertificateState(jsonResponse);
      })
      .catch(error => console.log(error));
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  handlePageClick = selectedPage => {
    pugCertificateService
      .getAll(selectedPage.selected + 1)
      .then(jsonResponse => {
        this.setPugCertificateState(jsonResponse);
      })
      .catch(error => console.log(error));
  };

  setPugCertificateState = response => {
    let existingCertificates = { ...this.state.existingCertificates };
    let pagination = { ...this.state.pagination };
    existingCertificates = response.pug_certificates;
    pagination = response.pagination;

    this.setState({ existingCertificates });
    this.setState({ pagination });
  };

  updateField = event => {
    const field = event.target.name;
    const newCertificate = this.state.newCertificate;
    newCertificate[field] = event.target.value;

    this.setState({
      newCertificate
    });
  };

  onDropDocument = documents => {
    let newCertificate = { ...this.state.newCertificate };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newCertificate.document = documents[0];

      self.setState({ newCertificate });
      self.setState({ disabledDocument: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removeDocuments = () => {
    let newCertificate = { ...this.state.newCertificate };
    newCertificate.document = null;

    this.setState({ newCertificate });
    this.setState({ disabledDocuments: false });
  };

  resetForm = () => {
    let newCertificate = { ...this.state.newCertificate };
    newCertificate = {
      title: '',
      document: ''
    };

    this.setState({ newCertificate });
    this.setState({ disabledDocuments: false });
  };

  handleFormSubmit = event => {
    event.preventDefault();
    const currentId = this.state.newCertificate.id;

    const headers = {
      Accept: 'application/json'
    };

    if (this.authentication.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.authentication.getToken();
    }

    let url = `${process.env.REACT_APP_API_URL}/api/pug_certificates/`;
    let callMethod = 'POST';

    if (currentId) {
      url = `${process.env.REACT_APP_API_URL}/api/pug_certificates/${this.state.newCertificate.id}`;
      callMethod = 'PUT';
    }

    const formattedData = this.buildFormData(this.state.newCertificate);

    fetch(url, {
      method: callMethod,
      body: formattedData,
      headers
    })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(jsonResponse => {
        this.resetForm();

        let existingCertificates = this.state.existingCertificates.slice();

        let index = existingCertificates.findIndex(
          certificate => certificate.id === jsonResponse.id
        );

        if (index !== -1) {
          existingCertificates[index] = jsonResponse;
        } else {
          existingCertificates.push(jsonResponse);
        }

        this.setState({ existingCertificates });

        if (currentId) {
          this._notificationSystem.addNotification({
            message: 'Certificatul a fost editat cu success.',
            level: 'success',
            position: 'tc'
          });
        } else {
          this._notificationSystem.addNotification({
            message: 'Certificatul a fost adaugat cu success.',
            level: 'success',
            position: 'tc'
          });
        }
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  buildFormData() {
    let formData = new FormData();
    formData.append('pug_certificate[title]', this.state.newCertificate.title);

    formData.append('pug_certificate[add_date]', this.state.newCertificate.date);

    if (this.state.newCertificate.document) {
      let document = this.state.newCertificate.document;
      formData.append(`pug_certificate[document]`, document, document.name);
    }

    return formData;
  }

  setCertificateForEdit = certificate => {
    let newCertificate = { ...this.state.newCertificate };
    newCertificate = Object.assign({}, certificate);
    this.setState({ newCertificate });
    this.setState({ disabledDocuments: true });
  };

  openDeleteDialog = id => {
    let deleteCertificate = { ...this.state.deleteCertificate };
    deleteCertificate = {
      openedDialog: true,
      deleteId: id
    };

    this.setState({ deleteCertificate });
  };

  closeDeleteDialog = () => {
    let deleteCertificate = { ...this.state.deleteCertificate };
    deleteCertificate = {
      openedDialog: false,
      deleteId: 0
    };

    this.setState({ deleteCertificate });
  };

  handleDelete = () => {
    pugCertificateService
      .deletePugCertificate(this.state.deleteCertificate.deleteId)
      .then(() => {
        let existingCertificates = this.state.existingCertificates.slice();
        existingCertificates = existingCertificates.filter(
          certificate =>
            certificate.id !== this.state.deleteCertificate.deleteId
        );
        this.setState({ existingCertificates });

        this.closeDeleteDialog();

        this._notificationSystem.addNotification({
          message: 'Certificatul a fost sters cu success.',
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  handleErrors = response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  };

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h3 className="admin-page__profile-title profile-title-specific">
            Plan Urbanistic General
          </h3>
          <h1 className="admin-switch-title default-title">
            Certificate de Urbanism
          </h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">
                  Adauga un certificat nou de urbanism
                </h2>
                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Titlu certificat*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="text"
                    name="title"
                    onChange={this.updateField}
                    value={this.state.newCertificate.title}
                  />
                </div>
                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Data certificat*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="date"
                    name="date"
                    onChange={this.updateField}
                    value={this.state.newCertificate.date}
                  />
                </div>
                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Document Certificat de Urbanism:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropDocument}
                    removeDocument={this.removeDocument}
                    disabledDocuments={this.state.disabledDocument}
                    document={this.state.newCertificate.document}
                    documentFilename={
                      this.state.newCertificate.document_filename
                    }
                    type="application/pdf"
                  />
                </div>
                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button
                      type="submit"
                      className="submit-button general-button"
                    >
                      {this.state.newCertificate.id
                        ? 'Editează certificat'
                        : 'Adaugă certificat'}
                    </button>
                  </div>
                  {Object.values(this.state.newCertificate) && (
                    <button
                      type="button"
                      className="general-button reset-button"
                      onClick={() => this.resetForm()}
                    >
                      Resetează câmpurile
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
          {this.state.existingCertificates.length > 0 && (
            <div className="admin-standard-page__existing-items">
              <div className="card">
                <div className="existing-items">
                  <h2 className="existing-items__title label-title">
                    Certificate de urbanism existente
                  </h2>
                  <div className="existing-items__content">
                    {this.state.existingCertificates.map(certificate => (
                      <div
                        className="existing-items__content-card"
                        key={certificate.id}
                      >
                        <div className="card-content provisions-title-content">
                          <h3 className="major-provisions-title">
                            {certificate.title}
                          </h3>
                        </div>
                        <div className="existing-items__actions-card">
                          <div
                            className="provisions-title-content"
                            onClick={() =>
                              this.setCertificateForEdit(certificate)
                            }
                          >
                            <h4 className="action-title"> Editează</h4>
                          </div>

                          <div
                            className="provisions-title-content"
                            onClick={() =>
                              this.openDeleteDialog(certificate.id)
                            }
                          >
                            <h4 className="action-title delete-button">
                              {' '}
                              Șterge
                            </h4>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <DeletePUGCertificates
                    opened={this.state.deleteCertificate.openedDialog}
                    handleClose={this.closeDeleteDialog}
                    handleDelete={this.handleDelete}
                    headline="Sunteti sigur ca doriti sa stergeti acest certificat?"
                    aditionalText="Dupa stergere, certificatul nu va mai putea fi recuperat."
                  />
                </div>
                {this.state.pagination.last_page > 1 && (
                  <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pagination.last_page}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}

export default PUGCertificate;
